<!-- 講座詳細 -->
<script setup lang="ts">
  import { PlanInfo } from "~/entities/PlanInfo";

  interface Props {
    planInfo: PlanInfo;
  }
  const props = withDefaults(defineProps<Props>(), {
    planInfo: undefined,
  });

  // 自身が本講座のオーナーかどうか
  const isOwner = computed<boolean>(() => props.planInfo?.isOwner);
</script>

<template>
  <div v-if="isOwner" class="mb-1 d-flex justify-end">
    <NuxtLink
      class="text-right text-main-01 d-flex justify-end align-end text-decoration-none cursor-pointer"
      :to="`/plan/${planInfo.id}/edit`"
    >
      <v-icon icon="$mdiCogOutline" size="small"></v-icon>
      <span class="ml-1">講座内容を編集する</span>
    </NuxtLink>
  </div>
  <OrganismsPlanDetailLayout>
    <template #thumbnail>
      <!-- サムネイル -->
      <v-responsive :aspect-ratio="16 / 9" class="border mb-4" align="center">
        <v-img :src="planInfo?.thumbnailImage" containt class="plan-img rounded" aspect-ratio="16/9" />
      </v-responsive>
    </template>
    <template #detail>
      <!-- 講座紹介マークダウン -->
      <OrganismsPlanIntroductions v-if="planInfo" :plan-info="planInfo" :is-edit="false" :is-view="true" />
    </template>
    <template #summary>
      <OrganismsPlanHeader
        :plan-info="planInfo"
        :is-owner="isOwner"
        :style="{ marginBottom: planInfo?.isContract ? '8px' : '16px' }"
      />
    </template>
  </OrganismsPlanDetailLayout>
</template>

<style lang="scss" scoped>
  @import "assets/media.scss";
  .plan-img {
    width: 100%;
    height: auto;
  }
</style>
